<template>
  <v-layout row wrap>
    <v-dialog v-model="scenarioVisible" persistent max-width="482px">
      <v-card class="mx-auto">
        <v-toolbar dark color="primary" height="45">
          <v-toolbar-title>{{ modalTitle }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn small icon color="primary" @click="toggleScenarioModal"
              ><v-icon>close</v-icon></v-btn
            >
          </v-toolbar-items>
        </v-toolbar>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12>
                <v-text-field
                  label="Scenario Name"
                  v-model="modalScenarioName"
                  required
                  :rules="[v => !!v || 'Scenario name is required']"
                />
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="saveScenarioName">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="saveScenarioVisible" persistent max-width="482px">
      <v-card class="mx-auto">
        <v-toolbar dark color="primary" height="45">
          <v-toolbar-title>Save Scenario</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn small icon color="primary" @click="toggleSaveScenarioModal"
              ><v-icon>close</v-icon></v-btn
            >
          </v-toolbar-items>
        </v-toolbar>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12>
                <strong>Override scenario parameters</strong>
              </v-flex>
              <v-flex xs12>
                <v-text-field
                  label="Scenario Name"
                  v-model="scenarioData.scenarioName"
                  required
                  :rules="[v => !!v || 'Scenario name is required']"
                />
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="saveScenario">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="matrixVisible" persistent max-width="482px">
      <v-card class="mx-auto">
        <v-toolbar dark color="primary" height="45">
          <v-toolbar-title>{{ modalMatrixTitle }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn small icon color="primary" @click="toggleMatrixModal"
              ><v-icon>close</v-icon></v-btn
            >
          </v-toolbar-items>
        </v-toolbar>
        <v-card-text>
          <kendo-grid
            ref="matrixGrid"
            :filterable="false"
            :sortable="false"
            :dataSource="matrixDataSource"
            :columns="matrixColumns"
            :pageable="false"
            :scrollable="true"
            :height="282"
            style="max-height:282px"
          ></kendo-grid>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="toggleMatrixModal">close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <send-bid-rate-pricer-report-form
      :clientId="clientId"
      :lastParams="lastParams"
      v-model="reportFormOpen"
    />
    <page-toolbar style="padding-bottom:6px">
      <div style="width:132px">
        <v-select
          label="Language"
          :items="languages"
          item-text="language"
          item-value="languageId"
          v-model="languageId"
          v-on:change="changeLanguage()"
          width="132"
        >
        </v-select>
      </div>
      <div style="padding-top:6px;padding-left:5px;display:none">
        <kendo-button type="button" @click="addScenario()" icon="add" title="Create New Scenario" />
      </div>
      <div style="padding-top:6px;padding-left:5px;display:none">
        <kendo-button
          type="button"
          @click="editScenario()"
          icon="edit"
          title="Edit Scenario Name"
        />
      </div>
      <div style="padding-top:6px;padding-left:5px">
        <kendo-button type="button" @click="onExport()" icon="excel" title="Export to Excel" />
      </div>
      <div style="padding-top:6px;padding-left:5px">
        <kendo-button icon="window" title="Send Report" @click="openReportForm" />
      </div>
    </page-toolbar>

    <table class="blueTable">
      <tr>
        <td colspan="2">
          <img src="/api/config/Client/getLogo?clientId=0" height="61px" alt="Logo" />
        </td>
      </tr>
      <tr>
        <td colspan="2">
          <strong>{{ labels.ccyPair }}:</strong>
          <drop-down-list
            :data-items="ccyPairs"
            data-item-key="ccyPairId"
            text-field="ccyPairCode"
            :value="selectedCcy"
            @change="changeSelectedCcy"
            style="width: 100px"
          />

          <strong>{{ labels.scenario }}:</strong>
          <drop-down-list
            :data-items="scenarios"
            data-item-key="bidRateScenarioId"
            text-field="scenarioName"
            v-model="selectedScenario"
            style="width: 140px"
            v-on:change="changeScenario"
          />
          <div style="padding-top:6px;padding-left:5px;display:inline">
            <kendo-button
              type="button"
              @click="deleteScenario"
              icon="delete"
              title="Delete Scenario"
            />
          </div>

          <strong>{{ labels.evaluationDate }}:</strong>
          <date-picker
            :value="evaluationDate"
            :format="'yyyy-MM-dd'"
            style="width: 120px;"
            @change="changeEvaluationDate"
          />
        </td>
      </tr>
      <tr>
        <th colspan="2" style="text-transform:uppercase;font-weight:bold">{{ labels.title }}</th>
      </tr>
      <tr>
        <th>
          <drop-down-list
            :data-items="buySellData"
            data-item-key="buySellId"
            text-field="code"
            v-model="selectedBuySell"
            :style="`width:${this.languageId == 1 ? 65 : 99}px`"
            v-on:change="changeBuySell"
          />
        </th>
        <td>{{ scenarioData.buy }}</td>
      </tr>
      <tr>
        <th>{{ scenarioData.isBuying ? labels.sell : labels.buy }}</th>
        <td>{{ scenarioData.sell }}</td>
      </tr>
      <tr>
        <th style="font-weight:bold">{{ labels.referenceRate }}</th>
        <td class="lightBlue">
          <kendo-numerictextbox
            id="referenceRateTextBox"
            :value="scenarioData.referenceRate"
            style="width:132px"
            :decimals="6"
            format="n6"
            :spinners="false"
            :style="'text-align:right'"
            @change="changeReferenceRate"
          />
        </td>
      </tr>
      <tr>
        <td colspan="2"></td>
      </tr>
      <tr>
        <th style="font-weight:bold">{{ labels.bidAmount }}</th>
        <td class="lightBlue">
          <kendo-numerictextbox
            id="bidAmountTextBox"
            v-model="scenarioData.bidAmount"
            style="width:132px"
            :decimals="0"
            format="n0"
            :round="true"
            :spinners="false"
            :style="'text-align:right'"
            @change="recalculate"
          />
        </td>
      </tr>
      <tr>
        <th>{{ labels.baseCcyAmount }}</th>
        <td style="padding-right:67px;text-align:right">
          {{
            baseCcyAmount.toLocaleString('en-US', {
              style: 'decimal',
              currency: this.scenarioData.buy,
              maximumFractionDigits: 0,
            })
          }}
        </td>
      </tr>
      <tr>
        <th style="font-weight:bold">{{ labels.bidDate }}</th>
        <td class="lightBlue">
          <date-picker
            :value="scenarioData.bidDate"
            :min="evaluationDate"
            :format="'yyyy-MM-dd'"
            @change="changeBidDate"
            style="width: 120px;"
          />
        </td>
      </tr>
      <tr>
        <th style="font-weight:bold">{{ labels.obtainedDate }}</th>
        <td class="lightBlue">
          <date-picker
            :value="scenarioData.obtainedDate"
            :format="'yyyy-MM-dd'"
            style="width: 120px;"
            :min="scenarioData.bidDate"
            @change="changeObtainedDate"
          />
        </td>
      </tr>
      <tr>
        <th>{{ labels.volatility }}</th>
        <td class="lightBlue">
          <div style="height:0px;position:relative;padding-right:67px;text-align:right">
            <kendo-numerictextbox
              id="volatilityTextBox"
              :value="scenarioData.volatility"
              style="width:132px"
              :decimals="2"
              format="n2"
              :spinners="false"
              :style="'text-align:right'"
              @change="changeVolatility"
            />
          </div>
          <span>
            <v-btn
              class="matrixIcon"
              small
              icon
              color="primary"
              title="Show Volatility Matrix"
              @click="openVolatilityMatrix"
            >
              <v-icon style="font-size:20px">list</v-icon>
            </v-btn>
          </span>
          <span>
            <v-btn
              small
              icon
              color="warning"
              title="Reset the Volatility rate"
              style="margin:1px;float:right;"
              @click="getVolatilityPoint"
            >
              <v-icon style="font-size:16px">fas fa-bolt</v-icon>
            </v-btn>
          </span>
        </td>
      </tr>
      <tr>
        <th>{{ labels.assuranceCost }}</th>
        <td style="padding-right:67px;text-align:right">
          {{
            (assuranceCost || 0).toLocaleString('en-US', {
              style: 'decimal',
              maximumFractionDigits: 0,
            })
          }}
        </td>
      </tr>
      <tr>
        <th style="font-weight:bold">{{ labels.startDate }}</th>
        <td class="lightBlue">
          <date-picker
            :min="scenarioData.obtainedDate"
            :value="scenarioData.startDate"
            :format="'yyyy-MM-dd'"
            style="width: 120px;"
            @change="changeStartDate"
          />
        </td>
      </tr>
      <tr>
        <th style="font-weight:bold">{{ labels.endDate }}</th>
        <td class="lightBlue">
          <date-picker
            :value="scenarioData.endDate"
            :min="scenarioData.startDate"
            :format="'yyyy-MM-dd'"
            style="width: 120px;"
            @change="changeEndDate"
          />
        </td>
      </tr>
      <tr>
        <th>{{ labels.fwdPoints }}</th>
        <td class="lightBlue">
          <div style="height:0px;position:relative;padding-right:67px;text-align:right">
            <kendo-numerictextbox
              id="fwdPointsTextBox"
              :value="scenarioData.fwdPoints"
              style="width:132px"
              :decimals="2"
              format="n2"
              :spinners="false"
              :style="'text-align:right'"
              @change="changeFwdPoints"
            />
          </div>
          <span>
            <v-btn
              class="matrixIcon"
              small
              icon
              color="primary"
              title="Show FX Forward curve"
              @click="openForwardMatrix"
            >
              <v-icon style="font-size:20px">list</v-icon>
            </v-btn>
          </span>
          <span>
            <v-btn
              small
              icon
              color="warning"
              title="Reset the Fwd Points"
              style="margin:1px;float:right;"
              @click="getFwdPoints"
            >
              <v-icon style="font-size:16px">fas fa-bolt</v-icon>
            </v-btn>
          </span>
        </td>
      </tr>
      <tr>
        <th>{{ labels.creditFactor }}</th>
        <td style="padding-right:67px;text-align:right">
          {{
            (scenarioData.creditFactor || 0).toLocaleString('en-US', {
              style: 'decimal',
              maximumFractionDigits: 2,
              minimumFractionDigits: 2,
            })
          }}
        </td>
      </tr>
      <tr>
        <th style="font-weight:bold">{{ labels.bidRate }}</th>
        <td class="lightGreen" style="padding-right:67px;text-align:right">
          {{
            (scenarioData.bidRate || 0).toLocaleString('en-US', {
              style: 'decimal',
              minimumFractionDigits: 6,
              maximumFractionDigits: 6,
            })
          }}
        </td>
      </tr>
      <tr>
        <td colspan="2" style="text-align:justify;font-size:12px;padding:1px;color:red">
          {{ labels.note }}
        </td>
      </tr>
      <tr>
        <td colspan="2" style="text-align:right">
          <v-btn
            color="blue primary"
            title="Save all scenario parameters "
            @click="toggleSaveScenarioModal"
            >Save</v-btn
          >
        </td>
      </tr>
      <tr>
        <td colspan="2" style="text-align:justify;font-size:12px;padding:10px">
          {{ labels.disclaimer }}
        </td>
      </tr>
    </table>
  </v-layout>
</template>

<script>
import axios from 'axios'
import PageToolbar from '@/components/PageToolbar'
import {kendoNumericFocus, kendoNumericMultiplierKeydown} from '@/helpers/kendo-helpers'
import SendBidRatePricerReportForm from '@/components/SendBidRatePricerReportForm'
import {DropDownList} from '@progress/kendo-vue-dropdowns'
import notification from '@/helpers/notification'
import params from '@/helpers/params'
import {mapGetters} from 'vuex'
import {DatePicker} from '@progress/kendo-vue-dateinputs'
import {format} from 'date-fns'
import confirm from '../../helpers/confirmation-window'

export default {
  name: 'FxBidRatePricer',
  components: {PageToolbar, DropDownList, SendBidRatePricerReportForm, DatePicker},
  async mounted() {
    const {data: languages} = await axios.get('/api/report/BidRate/getLanguages')
    this.languages = languages

    const {data: ccyPairs} = await axios.get('/api/report/BidRate/getCcyPairs', {
      params: {clientId: this.clientId},
    })
    this.ccyPairs = ccyPairs
    this.selectedCcy = this.ccyPairs[0]

    const {data: scenarios} = await axios.get(`/api/report/BidRate/getScenarios`, {
      params: {clientId: this.clientId},
    })
    this.scenarios = scenarios
    this.selectedScenario = scenarios[0]
    this.evaluationDate = this.selectedScenario.scenarioDate

    await this.getScenarioData()
    await this.getReportLabels()
    await this.getSpot()

    setTimeout(() => {
      kendo.jQuery('#referenceRateTextBox').focus(this.kendoNumericFocus)

      kendo
        .jQuery('#bidAmountTextBox')
        .keydown(this.kendoNumericMultiplierKeydown)
        .focus(this.kendoNumericFocus)
    }, 1000)
  },
  data() {
    return {
      evaluationDate: new Date(),
      selectedCcy: null,
      scenarioData: null,
      scenarios: [],
      selectedScenario: null,
      ccyPairs: [],
      languageId: 1,
      languages: [],
      labels: [],
      buySellData: [],
      selectedBuySell: null,
      lastParams: null,
      reportFormOpen: false,
      isNewScenario: false,
      scenarioVisible: false,
      modalTitle: 'New Scenario',
      modalScenarioName: '',
      saveScenarioVisible: false,
      matrixVisible: false,
      modalMatrixTitle: '',
      matrixDataSource: null,
      matrixColumns: [],
      isDirty: false,
      exportAfterSafe: false,
    }
  },
  computed: {
    baseCcyAmount() {
      return this.scenarioData.bidAmount * this.scenarioData.bidRate || 0
    },
    assuranceCost() {
      return (
        this.scenarioData.volatility * this.scenarioData.pointValue * this.scenarioData.bidAmount ||
        0
      )
    },
    ...mapGetters({clientId: 'authentication/selectedClientId'}),
    ...mapGetters({tokenString: 'authentication/tokenString'}),
  },
  methods: {
    kendoNumericFocus(e) {
      return kendoNumericFocus.call(e.target, e)
    },
    kendoNumericMultiplierKeydown(e) {
      return kendoNumericMultiplierKeydown.call(e.target, e)
    },
    changeLanguage() {
      this.getReportLabels()
    },
    changeScenario({target}) {
      this.selectedScenario = target.value
      this.getScenarioData()
    },
    changeBuySell({target}) {
      this.selectedBuySell = target.value
      this.scenarioData.isBuying = this.selectedBuySell.buySellId == 1
      this.recalculate()
    },
    async getReportLabels() {
      const {data: labels} = await axios.get('/api/report/BidRate/getReportLabels', {
        params: {languageId: this.languageId, ccyPairId: this.selectedCcy.ccyPairId},
      })
      this.labels = labels
      this.buySellData = [
        {buySellId: 1, code: this.labels.buy},
        {buySellId: 2, code: this.labels.sell},
      ]
      this.selectedBuySell = this.scenarioData.isBuying ? this.buySellData[0] : this.buySellData[1]
    },
    async getScenarios(persist) {
      const {data: scenarios} = await axios.get(`/api/report/BidRate/getScenarios`, {
        params: {clientId: this.clientId},
      })
      this.scenarios = scenarios
      if (!persist) {
        this.selectedScenario = scenarios[0]
        this.evaluationDate = this.selectedScenario.scenarioDate
      }
    },
    async getScenarioData() {
      const {data: scenarioData} = await axios.get(`/api/report/BidRate/getScenarioData`, {
        params: {
          bidRateScenarioId: this.isNewScenario ? 0 : this.selectedScenario.bidRateScenarioId,
          clientId: this.clientId,
          ccyPairId: this.selectedCcy.ccyPairId,
          evaluationDate: this.evaluationDate,
        },
      })

      scenarioData.bidDate = new Date(scenarioData.bidDate)
      scenarioData.obtainedDate = new Date(scenarioData.obtainedDate)
      scenarioData.startDate = new Date(scenarioData.startDate)
      scenarioData.endDate = new Date(scenarioData.endDate)

      this.selectedCcy = this.ccyPairs.find(c => c.ccyPairId === scenarioData.ccyPairId)

      scenarioData.endDate = new Date(scenarioData.endDate)

      this.scenarioData = scenarioData
      this.isDirty = false
      this.evaluationDate = new Date(this.scenarioData.scenarioDate)
      this.selectedBuySell = this.scenarioData.isBuying ? this.buySellData[0] : this.buySellData[1]
    },
    async getSpot() {
      const {data: spot} = await axios.get(`/api/report/BidRate/GetSpot`, {
        params: {
          evaluationDate: this.adjustDate(this.evaluationDate),
          ccyPairId: this.selectedCcy.ccyPairId,
        },
      })
      this.scenarioData.referenceRate = spot
    },
    doExport() {
      const qs = params.fromObject({
        bidRateScenarioId: this.selectedScenario.bidRateScenarioId,
        evaluationDate: this.evaluationDate,
        ccyPairId: this.selectedCcy.ccyPairId,
        languageId: this.languageId,
        clientId: this.clientId,
        url: location.origin,
        t: this.tokenString,
      })
      location.href = `/api/report/BidRate/exportBidRatePricer?${qs}`
      this.exportAfterSafe = false
    },
    onExport() {
      if (this.isDirty) {
        const {scenarioName} = this.selectedScenario
        confirm.openConfirmationWindow(
          'Save before export?',
          `There are changes on scenario "${scenarioName}" do you want to save before export?`,
          async () => {
            this.exportAfterSafe = true
            this.toggleSaveScenarioModal()
          },
          this.doExport,
        )
        return
      }

      this.doExport()
    },
    openReportForm() {
      this.lastParams = {
        bidRateScenarioId: this.selectedScenario.bidRateScenarioId,
        evaluationDate: this.evaluationDate,
        ccyPairId: this.selectedCcy.ccyPairId,
        languageId: this.languageId,
        clientId: this.clientId,
        url: location.origin,
      }

      this.reportFormOpen = true
    },
    toggleScenarioModal() {
      this.scenarioVisible = !this.scenarioVisible
    },
    addScenario() {
      this.isNewScenario = true
      this.modalTitle = 'Create New Scenario'
      this.modalScenarioName = 'Scenario'
      this.toggleScenarioModal()
    },
    editScenario() {
      this.isNewScenario = false
      this.modalTitle = 'Edit Scenario'
      this.modalScenarioName = this.scenarioData.scenarioName
      this.toggleScenarioModal()
    },
    saveScenarioName() {
      if (this.isNewScenario) {
        this.evaluationDate = new Date()
        this.getScenarioData()
        this.scenarioData.scenarioName = this.modalScenarioName
        this.saveScenarioData()
        let newScenario = {
          bidRateScenarioId: this.scenarioData.bidRateScenarioId,
          scenarioName: this.scenarioData.scenarioName,
          scenarioDate: this.scenarioData.scenarioDate,
        }
        this.scenarios.push(newScenario)
        this.selectedScenario = newScenario
        this.isNewScenario = false
      } else {
        this.scenarioData.scenarioName = this.modalScenarioName
        this.selectedScenario.scenarioName = this.modalScenarioName
        this.saveScenarioData()
      }
      this.toggleScenarioModal()
    },
    toggleSaveScenarioModal() {
      this.saveScenarioVisible = !this.saveScenarioVisible
    },
    async saveScenario() {
      await this.saveScenarioData()
      if (this.exportAfterSafe) {
        this.doExport()
      }
      this.toggleSaveScenarioModal()
    },
    adjustDate(date) {
      const tzOffset = date.getTimezoneOffset() * 60000
      return new Date(date - tzOffset).toISOString().slice(0, 10)
    },
    async saveScenarioData(dryRun = false) {
      const request = {
        dryRun,
        bidRateScenarioId: this.isNewScenario ? 0 : this.selectedScenario.bidRateScenarioId,
        clientId: this.clientId,
        scenarioName: this.scenarioData.scenarioName,
        scenarioDate: this.adjustDate(this.evaluationDate),
        ccyPairId: this.selectedCcy.ccyPairId,
        isBuying: this.scenarioData.isBuying,
        buy: this.scenarioData.buy,
        sell: this.scenarioData.sell,
        referenceRate: this.scenarioData.referenceRate,
        bidAmount: this.scenarioData.bidAmount,
        bidDate: this.adjustDate(this.scenarioData.bidDate),
        obtainedDate: this.adjustDate(this.scenarioData.obtainedDate),
        volatility: this.scenarioData.volatility,
        startDate: this.adjustDate(this.scenarioData.startDate),
        endDate: this.adjustDate(this.scenarioData.endDate),
        fwdPoints: this.scenarioData.fwdPoints,
        creditFactor: this.scenarioData.creditFactor,
        bidRate: this.scenarioData.bidRate,
        pointValue: this.scenarioData.pointValue,
      }

      const {data, status} = await axios.post(`/api/report/BidRate/saveScenarioBidRate`, request)
      if (status == 200) {
        if (this.scenarioData.bidRateScenarioId != data.bidRateScenarioId) {
          this.getScenarios(true)
          this.selectedScenario.bidRateScenarioId = data.bidRateScenarioId
          this.selectedScenario.scenarioName = data.scenarioName
          this.selectedScenario.scenarioDate = data.scenarioDate
        }
        if (!dryRun) {
          this.selectedScenario.bidRateScenarioId = data.bidRateScenarioId
          this.selectedScenario.scenarioName = data.scenarioName
          this.selectedScenario.scenarioDate = data.scenarioDate
          this.scenarioData.scenarioName = data.scenarioName
          this.evaluationDate = new Date(data.scenarioDate)
          this.selectedCcy.ccyPairId = data.ccyPairId
          this.scenarioData.isBuying = data.isBuying
          this.scenarioData.buy = data.buy
          this.scenarioData.sell = data.sell
          this.scenarioData.referenceRate = data.referenceRate
          this.scenarioData.bidAmount = data.bidAmount
          this.scenarioData.bidDate = new Date(data.bidDate)
          this.scenarioData.obtainedDate = new Date(data.obtainedDate)
          this.scenarioData.startDate = new Date(data.startDate)
          this.scenarioData.endDate = new Date(data.endDate)
          this.isDirty = false
        }

        this.scenarioData.volatility = data.volatility
        this.scenarioData.fwdPoints = data.fwdPoints
        this.scenarioData.creditFactor = data.creditFactor
        this.scenarioData.bidRate = data.bidRate

        !dryRun && notification('FX Bid Rate save successfully!', 'info')
      } else {
        notification('Some error', 'error')
      }
    },
    deleteScenario() {
      const scenarioName = this.selectedScenario.scenarioName
      confirm.openConfirmationWindow(
        'Delete?',
        `Are you sure you want to delete the scenario "${scenarioName}" ?`,
        async () => {
          const bidRateScenarioId = this.isNewScenario ? 0 : this.selectedScenario.bidRateScenarioId
          const {status} = await axios.delete(`/api/report/BidRate/deleteScenarioBidRate`, {
            params: {bidRateScenarioId: bidRateScenarioId},
          })
          if (status == 200) {
            this.getScenarios()
            this.getScenarioData()
            notification('FX Bid Rate delete successfully!', 'info')
          } else {
            notification('Some error', 'error')
          }
        },
      )
    },
    toggleMatrixModal() {
      this.matrixVisible = !this.matrixVisible
    },
    async openVolatilityMatrix() {
      const {
        data: {curveData, curveDate},
      } = await axios.get(`/api/report/BidRate/getVolatilityCurve`, {
        params: {
          evaluationDate: this.adjustDate(this.evaluationDate),
          ccyPairId: this.selectedCcy.ccyPairId,
        },
      })
      this.modalMatrixTitle = `FX Volatility Matrix Date ${format(curveDate, 'YYYY-MM-DD')}`
      this.matrixDataSource = new kendo.data.DataSource({
        data: curveData,
        schema: {
          model: {
            fields: {endDate: {type: 'date'}, nbDays: {type: 'number'}, value: {type: 'number'}},
          },
        },
      })
      this.matrixColumns = [
        {
          field: 'endDate',
          title: 'End Date',
          width: 82,
          format: '{0:yyyy-MM-dd}',
          attributes: {style: 'text-align:left'},
        },
        {
          field: 'nbDays',
          title: 'Nb Days',
          width: 60,
          format: '{0:n0}',
          attributes: {style: 'text-align:right'},
        },
        {
          field: 'value',
          title: this.selectedCcy.ccyPairCode + ' bps',
          width: 82,
          format: '{0:n1}',
          attributes: {style: 'text-align:right'},
        },
      ]
      this.toggleMatrixModal()
    },
    async openForwardMatrix() {
      const {
        data: {curveData, curveDate},
      } = await axios.get(`/api/report/BidRate/getForwardCurve`, {
        params: {
          evaluationDate: this.adjustDate(this.evaluationDate),
          ccyPairId: this.selectedCcy.ccyPairId,
          referenceRate: this.scenarioData.referenceRate,
        },
      })

      this.modalMatrixTitle = `FX Forward Curve Date ${format(curveDate, 'YYYY-MM-DD')}`

      this.matrixDataSource = new kendo.data.DataSource({
        data: curveData,
        schema: {
          model: {
            fields: {
              endDate: {type: 'date'},
              nbDays: {type: 'number'},
              rate: {type: 'number'},
              value: {type: 'number'},
            },
          },
        },
      })
      this.matrixColumns = [
        {
          field: 'endDate',
          title: 'End Date',
          width: 82,
          format: '{0:yyyy-MM-dd}',
          attributes: {style: 'text-align:left'},
        },
        {
          field: 'nbDays',
          title: 'Nb Days',
          width: 60,
          format: '{0:n0}',
          attributes: {style: 'text-align:right'},
        },
        {
          field: 'value',
          title: this.selectedCcy.ccyPairCode + ' bps',
          width: 82,
          template: '#=kendo.toString(value*10000, "n1") #',
          attributes: {style: 'text-align:right'},
        },
      ]
      this.toggleMatrixModal()
    },
    async changeEvaluationDate({value}) {
      value.setHours(0, 0, 0, 0)
      this.evaluationDate = value

      if (this.evaluationDate > this.scenarioData.bidDate) {
        this.scenarioData.bidDate = value
        this.changeBidDate({value})
      }

      await this.getSpot()
      await this.getVolatilityPoint(false)
      await this.getFwdPoints(false)
      this.recalculate()
    },
    changeBidDate({value}) {
      value.setHours(0, 0, 0, 0)
      this.scenarioData.bidDate = value
      if (this.scenarioData.bidDate > this.scenarioData.obtainedDate) {
        const nextWeek = new Date(value)
        nextWeek.setDate(value.getDate() + 7)
        this.scenarioData.obtainedDate = nextWeek
        this.changeObtainedDate({value: nextWeek})
      }
    },
    changeObtainedDate({value}) {
      value.setHours(0, 0, 0, 0)
      this.scenarioData.obtainedDate = value
      this.scenarioData.startDate = value
      this.changeStartDate({value})
    },
    async changeStartDate({value}) {
      value.setHours(0, 0, 0, 0)
      this.scenarioData.startDate = value
      if (this.scenarioData.startDate > this.scenarioData.endDate) {
        this.scenarioData.endDate = new Date(value)
      }
      await this.getVolatilityPoint(false)
      this.recalculate()
    },
    async changeEndDate({value}) {
      this.scenarioData.endDate = value
      await this.getFwdPoints(false)
      this.recalculate()
    },
    changeReferenceRate({sender}) {
      this.scenarioData.referenceRate = sender.value()
      this.recalculate()
    },
    changeVolatility({sender}) {
      this.scenarioData.volatility = sender.value()
      this.recalculate()
    },
    changeFwdPoints({sender}) {
      this.scenarioData.fwdPoints = sender.value()
      this.recalculate()
    },
    recalculate() {
      this.isDirty = true
      this.saveScenarioData(true)
    },
    async changeSelectedCcy({target}) {
      this.selectedCcy = target.value
      const ccies = this.selectedCcy.ccyPairCode.split('/')
      this.scenarioData.sell = ccies[0]
      this.scenarioData.buy = ccies[1]
      await this.getReportLabels()
      await this.getSpot()
      await this.getVolatilityPoint(false)
      await this.getFwdPoints(false)
      this.recalculate()
    },
    async getVolatilityPoint(recalc = true) {
      const {data: volatility} = await axios.get('/api/report/BidRate/getVolatilityPoint', {
        params: {
          evaluationDate: this.adjustDate(this.evaluationDate),
          ccyPairId: this.selectedCcy.ccyPairId,
          obtainedDate: this.adjustDate(this.scenarioData.obtainedDate),
          bidDate: this.adjustDate(this.scenarioData.bidDate),
        },
      })

      this.scenarioData.volatility = volatility
      if (recalc) {
        this.recalculate()
      }
    },
    async getFwdPoints(recalc = true) {
      const {
        data: {fwdPoints, creditFactor},
      } = await axios.get('/api/report/BidRate/getFwdPoints', {
        params: {
          evaluationDate: this.adjustDate(this.evaluationDate),
          ccyPairId: this.selectedCcy.ccyPairId,
          startDate: this.adjustDate(this.scenarioData.startDate),
          endDate: this.adjustDate(this.scenarioData.endDate),
          referenceRate: this.scenarioData.referenceRate,
          obtainedDate: this.adjustDate(this.scenarioData.obtainedDate),
          pointValue: this.scenarioData.pointValue,
        },
      })

      this.scenarioData.fwdPoints = fwdPoints
      this.scenarioData.creditFactor = creditFactor

      if (recalc) {
        this.recalculate()
      }
    },
  },
}
</script>

<style scoped>
table.blueTable {
  border: 1px solid #336699;
  width: 632px;
  font-size: 14px !important;
  text-align: center;
  border-collapse: collapse;
}
table.blueTable th {
  padding: 2px;
  background-color: #21345c;
  color: #fff;
  font-weight: normal;
  border-top: 1px solid #fff;
  border-bottom: 1px solid #fff;
  border-left: 1px solid #21345c;
  border-right: 1px solid #21345c;
  width: 60%;
  height: 16px;
}
table.blueTable td {
  padding: 0;
  background-color: #fff;
  color: #21345c;
  border: 1px solid #21345c;
  width: 40%;
  height: 16px;
}
table.blueTable td.lightBlue {
  padding: 1px;
  background-color: #89b8d6;
  color: #21345c;
  border: 1px solid #21345c;
  width: 40%;
  height: 16px;
}
table.blueTable td.lightGreen {
  padding: 2px;
  background-color: #acdb7d;
  color: #21345c;
  font-size: 16px;
  font-weight: bold;
  border: 1px solid #21345c;
  width: 40%;
  height: 16px;
}
.matrixIcon {
  margin: 2px;
  float: right;
}
</style>
